var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _path8, _rect2, _path9, _path0, _path1, _path10, _path11, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPublicissapient(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "publicissapient",
    xmlns: "http://www.w3.org/2000/svg",
    width: 377.044,
    height: 205.886,
    viewBox: "0 0 377.044 205.886",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_89985",
    "data-name": "Path 89985",
    d: "M110.337,52.187a24.7,24.7,0,0,1-14.76,4.92A22.858,22.858,0,0,1,72.491,34.4c0-12.489,10.6-22.708,23.086-22.708a24.7,24.7,0,0,1,14.76,4.92l4.92-4.92A29.941,29.941,0,0,0,95.577,4.5C78.925,4.5,65.3,17.746,65.3,34.02s13.625,29.52,30.277,29.52a29.941,29.941,0,0,0,19.68-7.191Z",
    transform: "translate(181.838 12.531)",
    fill: "#010101"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4494",
    "data-name": "Group 4494",
    transform: "translate(198.316 107.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89986",
    "data-name": "Path 89986",
    d: "M56.942,37.583a4.6,4.6,0,0,0,4.542-4.542A4.373,4.373,0,0,0,56.942,28.5,4.6,4.6,0,0,0,52.4,33.042,4.373,4.373,0,0,0,56.942,37.583Z",
    transform: "translate(-52.4 -28.5)",
    fill: "#ef4651"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1535",
    "data-name": "Rectangle 1535",
    width: 6.812,
    height: 59.041,
    transform: "translate(1.135 17.409)",
    fill: "#ef4651"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89987",
    "data-name": "Path 89987",
    d: "M56.87,33.842C56.87,17.568,44,4.7,28.485,4.7A28.044,28.044,0,0,0,6.912,14.919V4.7H.1V84.935H6.912V53.522A28.044,28.044,0,0,0,28.485,63.741C44,63.362,56.87,50.116,56.87,33.842ZM28.107,56.55c-11.732,0-21.194-9.462-21.573-21.573V34.22c0-12.489,9.84-22.33,21.573-22.33S49.679,22.109,49.679,34.22,40.217,56.55,28.107,56.55Z",
    transform: "translate(0.278 13.088)",
    fill: "#010101"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89988",
    "data-name": "Path 89988",
    d: "M42.785,92.141A28.044,28.044,0,0,0,64.358,81.922V92.141H71.17V33.1H64.358V43.319A28.044,28.044,0,0,0,42.785,33.1C27.268,33.1,14.4,46.346,14.4,62.242,14.4,78.894,27.268,92.141,42.785,92.141ZM21.212,62.62c0-12.489,9.84-22.33,21.573-22.33S64.358,50.509,64.358,62.62v.757c-.378,12.111-9.84,21.573-21.573,21.573C31.053,85.328,21.212,75.11,21.212,62.62Z",
    transform: "translate(40.099 92.172)",
    fill: "#ef4651"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89989",
    "data-name": "Path 89989",
    d: "M91.07,62.342C91.07,46.068,78.2,33.2,62.685,33.2A28.044,28.044,0,0,0,41.112,43.419V33.2H34.3v80.235h6.812V82.022A28.044,28.044,0,0,0,62.685,92.241C78.2,91.862,91.07,78.616,91.07,62.342ZM62.685,85.05c-11.732,0-21.194-9.462-21.573-21.573V62.72c0-12.489,9.84-22.33,21.573-22.33S84.258,50.609,84.258,62.72,74.417,85.05,62.685,85.05Z",
    transform: "translate(95.514 92.451)",
    fill: "#ef4651"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89990",
    "data-name": "Path 89990",
    d: "M59.153,4.6V39.419c0,9.462-7.569,17.031-17.409,17.409A17.047,17.047,0,0,1,24.712,39.419V4.6H17.9V39.419A24.068,24.068,0,0,0,41.743,63.641,24.392,24.392,0,0,0,65.965,39.419V4.6Z",
    transform: "translate(49.845 12.809)",
    fill: "#010101"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89991",
    "data-name": "Path 89991",
    d: "M62.685,17.409A28.044,28.044,0,0,0,41.112,27.628V0H34.3V76.45h6.812V66.232A28.044,28.044,0,0,0,62.685,76.45C78.2,76.45,91.07,63.2,91.07,47.308,91.07,30.656,78.2,17.409,62.685,17.409Zm21.573,29.9c0,12.489-9.84,22.33-21.573,22.33S41.112,59.419,41.112,47.308v-.757c.378-12.111,9.84-21.573,21.573-21.573C74.417,24.6,84.258,34.819,84.258,47.308Z",
    transform: "translate(95.514)",
    fill: "#010101"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89992",
    "data-name": "Path 89992",
    d: "M64.142,9.083a4.6,4.6,0,0,0,4.542-4.542A4.373,4.373,0,0,0,64.142,0,4.6,4.6,0,0,0,59.6,4.542,4.373,4.373,0,0,0,64.142,9.083Z",
    transform: "translate(165.966)",
    fill: "#010101"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1536",
    "data-name": "Rectangle 1536",
    width: 6.812,
    height: 59.041,
    transform: "translate(226.701 17.409)",
    fill: "#010101"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89993",
    "data-name": "Path 89993",
    d: "M87.042,9.083a4.6,4.6,0,0,0,4.542-4.542A4.373,4.373,0,0,0,87.042,0,4.6,4.6,0,0,0,82.5,4.542,4.373,4.373,0,0,0,87.042,9.083Z",
    transform: "translate(229.735)",
    fill: "#010101"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1537",
    "data-name": "Rectangle 1537",
    width: 6.812,
    height: 59.041,
    transform: "translate(313.37 17.409)",
    fill: "#010101"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89994",
    "data-name": "Path 89994",
    d: "M101.322,33.1a23.8,23.8,0,0,0-17.409,7.569V33.1H77.1V92.141h6.812V57.322a17.534,17.534,0,0,1,17.409-17.031,16.96,16.96,0,0,1,17.031,17.031V92.141h6.812V57.322A23.827,23.827,0,0,0,101.322,33.1Z",
    transform: "translate(214.697 92.172)",
    fill: "#ef4651"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89995",
    "data-name": "Path 89995",
    d: "M116.943,100.087h-.757c-.757,0-1.892.378-3.406.378-2.649,0-4.163-1.892-4.163-6.055V54.293h8.326V47.48h-8.326V27.8h-7.191V47.48H93.1v6.812h8.326v40.5c0,4.542.757,7.191,2.649,9.083,1.514,1.892,4.163,2.649,6.812,2.649a22.906,22.906,0,0,0,5.677-.757h.378Z",
    transform: "translate(259.252 77.414)",
    fill: "#ef4651"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89996",
    "data-name": "Path 89996",
    d: "M105.23,74.553A20.8,20.8,0,0,1,87.063,84.771c-11.354,0-20.816-9.083-21.573-20.816h46.551a3.337,3.337,0,0,0,3.406-3.028V60.55C114.313,45.032,102.2,33.3,87.063,33.3,71.168,33.3,58.3,46.546,58.3,62.82A28.834,28.834,0,0,0,87.063,91.962a28.406,28.406,0,0,0,23.843-13.246ZM87.442,39.734a21.094,21.094,0,0,1,20.816,17.409H65.869C68.519,46.925,76.845,39.734,87.442,39.734Z",
    transform: "translate(162.346 92.729)",
    fill: "#ef4651"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89997",
    "data-name": "Path 89997",
    d: "M38.6,62.973A17.746,17.746,0,0,0,34.819,60.7a48.037,48.037,0,0,0-10.6-3.028,4.8,4.8,0,0,0-2.271-.378,34.507,34.507,0,0,1-9.083-3.785C10.6,51.619,9.84,50.1,9.84,48.212c0-2.271,1.514-4.163,3.785-6.055a15.9,15.9,0,0,1,10.6-2.649c4.92.378,8.7,2.649,12.489,5.677l.378.378,4.92-4.542a14.409,14.409,0,0,0-2.271-1.892c-3.785-2.649-8.7-5.677-15.517-5.677a23.827,23.827,0,0,0-14.76,3.406C5.3,39.886,2.649,44.049,2.649,48.212a12.246,12.246,0,0,0,3.785,9.462c3.785,3.785,10.219,5.677,15.517,6.812a24.469,24.469,0,0,1,11.354,4.542c2.649,2.271,3.785,4.163,3.785,6.812,0,2.271-1.892,4.92-4.542,6.434a19.368,19.368,0,0,1-10.6,3.028c-5.3-.378-10.976-2.649-16.653-6.812l-.378-.378L0,82.653l.378.378c6.434,5.677,13.625,8.7,21.194,9.083a21.929,21.929,0,0,0,14.76-4.163c4.542-3.028,7.191-7.191,7.191-11.732C45.037,70.542,42.388,66,38.6,62.973Z",
    transform: "translate(0 92.956)",
    fill: "#ef4651"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89998",
    "data-name": "Path 89998",
    d: "M126.6,34.473a17.746,17.746,0,0,0-3.785-2.271,48.037,48.037,0,0,0-10.6-3.028,4.8,4.8,0,0,0-2.271-.378,34.509,34.509,0,0,1-9.083-3.785c-2.271-1.892-3.028-3.406-3.028-5.3,0-2.271,1.514-4.163,3.785-6.055a15.9,15.9,0,0,1,10.6-2.649c4.92.378,8.7,2.649,12.489,5.677l.378.378,4.92-4.542a14.408,14.408,0,0,0-2.271-1.892c-3.785-2.649-8.7-5.677-15.517-5.677a23.827,23.827,0,0,0-14.76,3.406c-4.163,3.028-6.812,7.191-6.812,11.354a12.246,12.246,0,0,0,3.785,9.462c3.785,3.785,10.219,5.677,15.517,6.812a24.469,24.469,0,0,1,11.354,4.542c2.649,2.271,3.785,4.163,3.785,6.812,0,2.271-1.892,4.92-4.542,6.434a19.368,19.368,0,0,1-10.6,3.028c-5.3-.378-10.976-2.649-16.652-6.812l-.378-.378L88,54.153l.378.378c6.434,5.677,13.625,8.7,21.194,9.083a21.929,21.929,0,0,0,14.76-4.163c4.542-3.028,7.191-7.191,7.191-11.732C133.037,42.042,130.767,37.5,126.6,34.473Z",
    transform: "translate(245.05 13.593)",
    fill: "#010101"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1538",
    "data-name": "Rectangle 1538",
    width: 6.812,
    height: 76.072,
    transform: "translate(199.452 0.378)",
    fill: "#010101"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicissapient);
export default __webpack_public_path__ + "static/media/publicissapient.0658807a5916da0d9359a5a2582cd614.svg";
export { ForwardRef as ReactComponent };